import React, { useState } from "react";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";  // เพิ่ม
import WelcomeName from "./WelcomeName";
import { ProSidebarProvider } from "react-pro-sidebar";
import SideBar from "./SideBar";
import { Dropdown } from "react-bootstrap";
import logo3 from "../3W.svg";
import HomeIcon from "@mui/icons-material/Home";
import ReminderBell from "./Customer/ReminderBell";
import CommentBell from "./Customer/CommentBell";
// เพิ่ม import
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
// Role list สำหรับ test (ROLE_ID ตามระบบจริง)
const TEST_ROLES = [
  { label: "Sales", id: "1" },
  { label: "Accounting Officer", id: "12" },
  { label: "Accounting Manager", id: "13" },
  { label: "CFO", id: "16" },
  { label: "Purchasing", id: "17" },
];

const NavBar = () => {
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const activeOverride = localStorage.getItem("dev_role_override");

  const [open, setOpen] = useState(false);

  const handleSelect = (eventKey) => {
    localStorage.setItem("GET_FONT_SIZE", JSON.stringify(eventKey));
    window.location.reload();
  };

  const handleSwitchRole = (id) => {
    localStorage.setItem("dev_role_override", id);
    window.location.reload();
  };

  const handleResetRole = () => {
    localStorage.removeItem("dev_role_override");
    window.location.reload();
  };

  const isDev = process.env.NODE_ENV !== "production";

  return (
    <div className="navBar">
      <AppBar position="static">
        <Toolbar sx={{ flexWrap: "wrap", gap: { xs: 0.5, sm: 2 }, alignItems: "center" }}>
          <Typography sx={{ flexGrow: 1 }}>
            <a href="/s-crm/Home" className="home-button">
              <img alt="SINO Logo" src={logo3} className="logo" />
              <span className="navbar-brandtext home-button">S-CRM</span>
            </a>
          </Typography>

          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Dropdown onSelect={handleSelect}>
              <Dropdown.Toggle id="dropdown-basic" variant="Secondary">
                Font Size:{JSON.parse(localStorage.getItem("GET_FONT_SIZE"))}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item eventKey="Small">Small</Dropdown.Item>
                <Dropdown.Item eventKey="Normal">Normal</Dropdown.Item>
                <Dropdown.Item eventKey="Large">Large</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Box>

          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <a href="/s-crm/Home" className="home-button">
              <HomeIcon />
            </a>
          </Box>

          {getUserID && ["1", "2", "3", "7", "9", "14"].includes(getUserRole) && (
            <>
              <Box sx={{ zIndex: { xs: "auto", sm: 2000 } }}>
                <CommentBell userId={getUserID} />
              </Box>
              <Box sx={{ zIndex: { xs: "auto", sm: 2000 } }}>
                <ReminderBell userId={getUserID} />
              </Box>
            </>
          )}

          {/* ── 🧪 Role Switcher (dev/test only) ── */}
          {isDev && (
            <Box>
              <Button
                size="small"
                variant="outlined"
                onClick={(e) => setOpen(e.currentTarget)}
                sx={{ fontSize: "11px", textTransform: "none", borderColor: "rgba(255,255,255,0.5)", color: "#fff" }}
              >
               {activeOverride
                  ? TEST_ROLES.find((r) => r.id === activeOverride)?.label ?? "Override"
                  : "Switch Role"}
              </Button>

              <Menu
                anchorEl={open}
                open={Boolean(open)}
                onClose={() => setOpen(null)}
                slotProps={{
                  paper: {
                    sx: {
                      minWidth: 200,
                      width: 200,        // เพิ่ม
                      "& ul": {          // เพิ่ม — force list ใน Menu ให้ wrap
                        display: "flex",
                        flexDirection: "column",
                        padding: 0,
                      }
                    }
                  }
                }}
              >
                <MenuItem disabled sx={{ fontSize: "11px", opacity: 1, fontWeight: "bold" }}>
                  🧪 Test Role Switcher
                </MenuItem>
                <Divider />
                {TEST_ROLES.map((role) => (
                  <MenuItem
                    key={role.id}
                    selected={activeOverride === role.id}
                    onClick={() => handleSwitchRole(role.id)}
                    sx={{ fontSize: "12px" }}
                  >
                    {role.label}
                  </MenuItem>
                ))}
                {activeOverride && (
                  <>
                    <Divider />
                    <MenuItem onClick={handleResetRole} sx={{ fontSize: "12px", color: "error.main" }}>
                      ↩ Reset to original
                    </MenuItem>
                  </>
                )}
              </Menu>
            </Box>
          )}

          <Box sx={{ mx: 2 }}>
            <WelcomeName />
          </Box>
          <ProSidebarProvider>
            <SideBar />
          </ProSidebarProvider>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default NavBar;